<div class="wrapper d-flex flex-column">
  <app-confirm-popup *ngIf="showModal" [title]="'Delete'"
    [message]="'Are you sure you want to delete the selected EDP/AR association(s)?'" [confirmText]="'Delete'"
    [triggerModal]="showModal" [cancelText]="'Cancel'" (confirm)="onDeleteConfirm()"
    (cancel)="onDeleteCancel()"></app-confirm-popup>
  <div class="header d-flex row align-items-center">
    <div class="col-md-9">
      <h6 class="px-4 py-3">EDP/AR Mapping</h6>
    </div>
  </div>
  <div class="link-options-block mt-3 row mb-2">
    <ng-container>
      <div class="col-md-12 d-flex align-items-center row search-input-wrapper mb-4">
        <label class="form-label">EDP/AR # <span class="text-danger">*</span></label>
        <div class="col-md-10 d-flex flex-column mb-2 custom-select-v2">
          <nz-select nzMode="multiple" [(ngModel)]="edpArValue" [nzDropdownRender]="dropDownRender"
            #multiSelectRef="nzSelect" nzPlaceHolder="Enter EDP/AR #" [nzShowSearch]="true" [nzAllowClear]="true"
            (nzOnSearch)="searchCatalogEdpArNo($event)">
            @for (option of edpArNoList; track option) {
            <nz-option [nzLabel]="option" [nzValue]="option"></nz-option>
            }
          </nz-select>
          <span class="text-danger" *ngIf="edpArValue?.length == 0 && validateValues">
            Atleast one EDP/AR # value is required.
          </span>
          <ng-template #dropDownRender>

            <div class="d-flex justify-content-end p-2">
              <button nz-button nzType="primary" class="ok-btn" (click)="closeSelect(multiSelectRef)">
                Ok
              </button>
            </div>

          </ng-template>
        </div>
        <div class="col-md-2 d-flex mb-2">
          <button nz-button nzType="primary" [disabled]="DefaultExists || !authService.webAdm"
            (click)="pushDefault()">Default</button>
        </div>
      </div>
      <div class="col-md-12 d-flex align-items-center row search-input-wrapper mb-4">
        <div class="col-md-10 d-flex mb-1 px-3">
          <div class="d-flex flex-column w-100">
            <label class="form-label">Start Date & Time</label>
            <nz-date-picker class="mr-5" [nzDisabledDate]="disablePastDates" nzPlaceHolder="Select Start Date & Time"
              style="height: 35px;width: 100%;" [(ngModel)]="startDate" (ngModelChange)="openEndPicker()"
              [nzShowTime]="true"></nz-date-picker>
          </div>
          <div class="d-flex flex-column w-100">
            <label class="form-label">End Date & Time</label>
            <nz-date-picker class="ml-5" [nzDisabledDate]="startDate ? disabledDate : disablePastDates" #endDatePicker
              nzPlaceHolder="Select End Date & Time" style="height: 35px;width: 100%;" [(ngModel)]="endDate"
              [nzShowTime]="true"></nz-date-picker>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="col-md-12 d-flex flex-row mb-2 justify-content-end">
      <button (click)="resetForm()" nz-button nzType="default" [disabled]="!authService.webAdm">Reset</button>
      &nbsp;
      <button nz-button nzType="primary" (click)="updateAssociation()" class="d-flex align-items-center"
        [nzSize]="'default'" [disabled]="!authService.webAdm"><span nz-icon nzType="plus"></span>Add</button>
    </div>
  </div>

  <div class="associate-wrapper px-3">
    <div class="link-options-list p-2">
      <div class="link-option-header px-4 d-flex justify-content-between align-items-center">
        <label>Association List</label>
        <button nz-button nzType="primary" [disabled]="selectedIds.size == 0 || (!authService.webAdm)"
          (click)="deAssociate()">DeAssociate</button>
      </div>
      <ng-container>
        <div class="col-md-6 px-4 mt-2">
          <nz-input-group class="px-2 mr-2 search-input-group" style="width: 80%;height: 35px;" nzSize="default"
            [nzSuffix]="suffixIconSearch">
            <input type="text" class="py-1" nz-input placeholder="Search For EDP/AR #"
              (keydown.enter)="searchValue(SearchText.value,'edpArNo')" [(ngModel)]="searchText" nzAllowClear
              #SearchText />
            <span class="close-icon" (click)="SearchText.value = '';searchValue('','edpArNo')" class="px-1" nz-icon
              nzType="close-circle"></span>

          </nz-input-group>
          <ng-template #suffixIconSearch>
            <span class="search-icon" (click)="searchValue(SearchText.value,'edpArNo')" nz-icon nzType="search"></span>
          </ng-template>
        </div>
        <app-data-grid [columns]="edpColumns" [dataSet]="edp_ar_list" [gridStyle]="'white'"
          (deleteRow)="deleteRow($event)" (updateRow)="updateRow($event)" (selectedRows)="selectedRows($event)"
          [frontPagination]="false"></app-data-grid>
      </ng-container>
    </div>
  </div>
</div>